export default {
    state: {
        user: null,
        isAuthenticated: false,
        token: null, // 可选：存储 token
    },
    mutations: {
        SET_USER(state, userData) {
            state.user = userData;
            state.isAuthenticated = !!userData; // 转换为布尔值
            state.token = userData ? userData.token : null; // 可选：存储 token
        },
        CLEAR_USER(state) {
            state.user = null;
            state.isAuthenticated = false;
            state.token = null;
        },
    },
    getters: {
        isAuthenticated: (state) => state.isAuthenticated,
        user: (state) => state.user,
        token: (state) => state.token,
    },
    actions: {
        async login({ commit }, data) {
            commit("SET_USER", data.user); // 触发 mutation
        },
        logout({ commit }) {
            commit("CLEAR_USER"); // 退出登录
            this.$router.push("/login"); // 跳转登录页
        },
    },
};
